import { format, parseISO, isPast, isToday } from 'date-fns'
import { cn } from '../../../lib/utils'

export const TaskCard = ({ task, member, onToggle, onTap }) => {
  const done   = !!task.completed_at
  const due    = task.due_date ? parseISO(task.due_date) : null
  const overdue = due && !done && isPast(due) && !isToday(due)

  const color  = member?.profiles?.member_color
  const name   = member?.profiles?.display_name

  return (
    <div
      className={cn(
        'flex items-start gap-3 px-4 py-3 bg-surface rounded-xl border transition-colors cursor-pointer active:bg-background',
        done ? 'border-border opacity-60' : 'border-border hover:border-primary/30',
      )}
      onClick={() => onTap?.(task)}
    >
      {/* Checkbox */}
      <button
        onClick={(e) => { e.stopPropagation(); onToggle?.(task) }}
        className={cn(
          'mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors',
          done ? 'bg-emerald-400 border-emerald-400' : 'border-border hover:border-primary',
        )}
      >
        {done && (
          <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2.5">
            <path d="m2 6 3 3 5-5" />
          </svg>
        )}
      </button>

      <div className="flex-1 min-w-0">
        <p className={cn('text-sm font-medium text-text-primary leading-tight', done && 'line-through text-text-muted')}>
          {task.title}
        </p>

        {due && (
          <p className={cn('text-xs mt-0.5', overdue ? 'text-rose-500 font-semibold' : 'text-text-muted')}>
            {isToday(due) ? 'Today' : format(due, 'MMM d')}
            {overdue && ' · Overdue'}
          </p>
        )}

        {task.recurrence_rule && (
          <span className="text-[10px] text-text-muted bg-background px-1.5 py-0.5 rounded-full mt-1 inline-block">
            Recurring
          </span>
        )}
      </div>

      {/* Assignee chip */}
      {member?.profiles && (
        <span
          className="text-[10px] font-semibold px-2 py-0.5 rounded-full text-white flex-shrink-0 self-start mt-0.5"
          style={{ backgroundColor: color ?? '#7c6faf' }}
        >
          {name}
        </span>
      )}
    </div>
  )
}
